/* ============================================================================
   LAH — QUIZ DE INDICACAO DE LENTES MULTIFOCAIS
   Tema: Testes de implementacao (3.0)

   Tres perguntas de cotidiano recomendam campo de visao, espessura e
   tratamento — e APLICAM as escolhas no proprio fluxo, clicando nas opcoes.

   ============================================================================
   A DIFERENCA DE PRECO NAO E MAIS ANUNCIADA
   ============================================================================
   O resultado dizia, em destaque, quanto a opcao mais barata custaria a menos:
   "O campo Base custaria R$ 800 a menos".

   A intencao era transparencia. O efeito era outro: um numero grande em
   destaque logo abaixo da recomendacao faz a propria recomendacao parecer uma
   tentativa de empurrar o caro. Oitocentos reais nao se le como informacao —
   le-se como aviso.

   No lugar dele, um BOTAO DISCRETO com a alternativa economica e o preco dela.
   A diferenca continua disponivel (quem quiser subtrai), mas quem esta
   satisfeito com a indicacao nao leva um numero na cara.

   A troca tambem e melhor na pratica: antes o cliente lia a diferenca e
   precisava voltar sozinho para trocar a opcao. Agora troca num toque.

   ============================================================================
   ONDE O QUIZ FICA
   ============================================================================
   No TOPO da etapa, logo abaixo do titulo e antes das opcoes — o quiz e
   oferecido ANTES da paralisia diante de tres precos que vao de R$ 449 a
   R$ 1.249.

   ============================================================================
   POR QUE CLICAR NAS OPCOES EM VEZ DE ESCREVER O ESTADO
   ============================================================================
   O configurador guarda preco, etapas e proximo passo dentro de um componente
   Alpine. Escrever nesse estado por fora duplicaria a logica dele — e as duas
   copias divergiriam na primeira mudanca.

   ============================================================================
   A REGRA: MENOR COMBINACAO QUE ATENDE
   ============================================================================
     ESPESSURA e restricao, nao preferencia. O grau define. Recomendar abaixo
     do grau e vender uma lente que nao pode ser feita.

     TRATAMENTO e quase objetivo: telas pedem filtro azul, sol pede
     fotossensivel.

     CAMPO DE VISAO e onde o dinheiro esta. Parte sempre do mais barato e so
     sobe com justificativa. O Dinamico exige DOIS sinais simultaneos; com um
     so, venceria em quase todo cenario e o quiz viraria anuncio.

   Precos NUNCA sao escritos aqui: sao lidos dos proprios cartoes.
   ============================================================================ */

(function () {
    'use strict';

    var STEP_CAMPO = 'campo-de-visao';
    var STEP_ESPESSURA = 'espessura-de-suas-lentes-multifocais';
    var STEP_TRATAMENTO = 'tratamento';

    var root = document.querySelector('.product-lens-select');
    if (!root) return;

    var respostas = { usos: [], alterna: null, grau: null };
    var observer = null;

    function normalize(text) {
        return (text || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    }

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function moeda(centavos) {
        return (centavos / 100).toLocaleString('pt-BR', {
            style: 'currency', currency: 'BRL'
        });
    }

    function acharEtapa(fragmento) {
        var steps = root.querySelectorAll('.product-lens-select-step');
        for (var i = 0; i < steps.length; i++) {
            var s = steps[i].getAttribute('data-step-selector') || '';
            if (s.indexOf(fragmento) !== -1) return steps[i];
        }
        return null;
    }

    /* Comparacao normalizada: acento e caixa variam entre o metaobject e o que
       escrevemos aqui. */
    function acharOpcao(etapa, nomeAlvo) {
        if (!etapa) return null;
        var itens = etapa.querySelectorAll('.product-lens-select-item');
        var alvo = normalize(nomeAlvo);

        for (var i = 0; i < itens.length; i++) {
            if (normalize(itens[i].getAttribute('data-item-name')) === alvo) {
                return itens[i];
            }
        }
        return null;
    }

    function precoDaOpcao(item) {
        if (!item) return 0;
        var input = item.querySelector('input[name="item-variant-price"]');
        return input ? parseInt(input.value, 10) || 0 : 0;
    }

    /* ---------------------------------------------------------------------
       RECOMENDACAO
       --------------------------------------------------------------------- */
    function recomendar() {
        var usos = respostas.usos;
        var telas = usos.indexOf('telas') !== -1;
        var dirige = usos.indexOf('dirige') !== -1;
        var arLivre = usos.indexOf('ar_livre') !== -1;

        var campo = 'Base';
        var porqueCampo = 'Seu uso e mais estavel, entao o Base ja entrega nitidez e conforto.';

        if (respostas.alterna === 'muito' && dirige) {
            campo = 'Dinâmico';
            porqueCampo = 'Como voce alterna muito entre distancias e dirige com frequencia, a transicao suave e a menor distorcao nas laterais fazem diferenca real.';
        } else if (respostas.alterna === 'as_vezes' || respostas.alterna === 'muito' || telas) {
            campo = 'Amplo';
            porqueCampo = 'Voce alterna entre perto e longe com frequencia, e o campo maior facilita a adaptacao.';
        }

        var espessura = null;
        var porqueEspessura = '';

        if (respostas.grau === 'ate275') {
            espessura = 'Multifocal Normal';
            porqueEspessura = 'Seu grau esta dentro da faixa da lente padrao.';
        } else if (respostas.grau === 'ate475') {
            espessura = 'Multifocal Fina';
            porqueEspessura = 'A partir desse grau a lente fina evita peso e espessura na borda.';
        } else if (respostas.grau === 'acima5') {
            espessura = 'Multifocal Super Fina';
            porqueEspessura = 'Grau mais alto pede a lente mais fina para o oculos nao ficar pesado.';
        }

        var tratamento = 'Clássico';
        var porqueTratamento = 'Antirreflexo, protecao UV e anti-risco ja vem inclusos.';

        if (telas && arLivre) {
            tratamento = 'Filtro de luz azul + Fotossensível';
            porqueTratamento = 'Voce usa telas e passa tempo ao ar livre — os dois tratamentos se complementam.';
        } else if (telas) {
            tratamento = 'Filtro de luz azul';
            porqueTratamento = 'Voce passa bastante tempo em telas.';
        } else if (arLivre) {
            tratamento = 'Fotossensível';
            porqueTratamento = 'A lente escurece sozinha na luz do sol.';
        }

        return {
            campo: campo, porqueCampo: porqueCampo,
            espessura: espessura, porqueEspessura: porqueEspessura,
            tratamento: tratamento, porqueTratamento: porqueTratamento
        };
    }

    /* ---------------------------------------------------------------------
       RESULTADO
       --------------------------------------------------------------------- */
    function linha(rotulo, valor, preco, porque) {
        return '<div class="lah-quiz__row"><div>' +
            '<span class="lah-quiz__row-label">' + rotulo + '</span>' +
            '<p class="lah-quiz__why">' + porque + '</p></div>' +
            '<span class="lah-quiz__row-value">' + valor + '<br>' +
            (preco > 0 ? moeda(preco) : 'incluso') + '</span></div>';
    }

    function montarResultado(painel) {
        var r = recomendar();

        var etapaCampo = acharEtapa(STEP_CAMPO);
        var etapaEsp = acharEtapa(STEP_ESPESSURA);
        var etapaTrat = acharEtapa(STEP_TRATAMENTO);

        var optCampo = acharOpcao(etapaCampo, r.campo);
        var optEsp = r.espessura ? acharOpcao(etapaEsp, r.espessura) : null;
        var optTrat = acharOpcao(etapaTrat, r.tratamento);

        var total = precoDaOpcao(optCampo) + precoDaOpcao(optEsp) + precoDaOpcao(optTrat);

        var html = '<p class="lah-quiz__result-title">Nossa indicação para você</p>';

        html += linha('Campo de visão', r.campo, precoDaOpcao(optCampo), r.porqueCampo);

        if (r.espessura) {
            html += linha('Espessura', r.espessura, precoDaOpcao(optEsp), r.porqueEspessura);
        } else {
            html += '<div class="lah-quiz__row"><div>' +
                '<span class="lah-quiz__row-label">Espessura</span>' +
                '<p class="lah-quiz__why">Depende do seu grau, e sem ele não dá para indicar com segurança. ' +
                'Escolha na próxima etapa ou fale com a gente no WhatsApp.</p></div>' +
                '<span class="lah-quiz__row-value">a definir</span></div>';
        }

        html += linha('Tratamento', r.tratamento, precoDaOpcao(optTrat), r.porqueTratamento);

        html += '<div class="lah-quiz__total"><span>Lentes</span><strong>' +
            (r.espessura ? moeda(total) : 'a partir de ' + moeda(total)) +
            '</strong></div>';

        html += '<button type="button" class="lah-quiz__apply" data-quiz-aplicar>' +
            'Aplicar essa combinação</button>';

        /* ---------------------------------------------------------------
           ALTERNATIVA ECONOMICA

           Mesma combinacao, com o campo de visao mais barato — o unico eixo
           onde a diferenca de preco e grande. Espessura e restricao do grau e
           tratamento e necessidade; trocar qualquer um deles por economia
           seria recomendar a lente errada.

           Mostra o PRECO DELA, nao a diferenca: ver a nota no topo.
           --------------------------------------------------------------- */
        var temAlternativa = false;

        if (r.campo !== 'Base') {
            var optBase = acharOpcao(etapaCampo, 'Base');

            if (optBase) {
                var totalBase = precoDaOpcao(optBase) +
                    precoDaOpcao(optEsp) + precoDaOpcao(optTrat);

                html += '<button type="button" class="lah-quiz__alt" data-quiz-economica>' +
                    'Prefiro a opção mais econômica · ' +
                    (r.espessura ? moeda(totalBase) : 'a partir de ' + moeda(totalBase)) +
                    '</button>';

                temAlternativa = true;
            }
        }

        html += '<p class="lah-quiz__foot">Você pode trocar qualquer opção depois.</p>';

        painel.innerHTML = html;
        painel.classList.add('is-on');

        painel.querySelector('[data-quiz-aplicar]').addEventListener('click', function () {
            aplicar(r, false);
        });

        if (temAlternativa) {
            painel.querySelector('[data-quiz-economica]').addEventListener('click', function () {
                var economica = Object.assign({}, r, { campo: 'Base' });
                aplicar(economica, true);
            });
        }

        track('lens_quiz_resultado', {
            campo: r.campo,
            espessura: r.espessura || 'indefinida',
            tratamento: r.tratamento,
            valor_lentes: total / 100
        });
    }

    /* ---------------------------------------------------------------------
       APLICAR — clica nas opcoes, uma etapa por vez

       Cada clique faz o Alpine avancar e repintar. Esperamos a etapa seguinte
       aparecer antes do proximo clique, com tentativas limitadas: se algo
       mudar no configurador e a etapa nao vier, o quiz para em silencio e o
       cliente segue escolhendo com a mao — nunca trava.
       --------------------------------------------------------------------- */
    function clicarQuando(fragmentoEtapa, nomeOpcao, aoTerminar) {
        var tentativas = 0;

        (function tentar() {
            var etapa = acharEtapa(fragmentoEtapa);
            var opcao = etapa ? acharOpcao(etapa, nomeOpcao) : null;
            var visivel = etapa && etapa.offsetParent !== null;

            if (opcao && visivel) {
                opcao.click();
                requestAnimationFrame(function () {
                    setTimeout(aoTerminar, 90);
                });
                return;
            }

            tentativas++;
            if (tentativas > 40) {
                if (aoTerminar) aoTerminar();
                return;
            }

            setTimeout(tentar, 60);
        })();
    }

    function aplicar(r, economica) {
        track('lens_quiz_aplicado', {
            campo: r.campo,
            espessura: r.espessura || 'indefinida',
            tratamento: r.tratamento,
            economica: !!economica
        });

        clicarQuando(STEP_CAMPO, r.campo, function () {
            if (!r.espessura) return; /* para aqui: o cliente escolhe a espessura */

            clicarQuando(STEP_ESPESSURA, r.espessura, function () {
                clicarQuando(STEP_TRATAMENTO, r.tratamento, null);
            });
        });
    }

    /* ---------------------------------------------------------------------
       INTERFACE
       --------------------------------------------------------------------- */
    function grupo(pergunta, dica, nome, opcoes, multiplo) {
        var html = '<p class="lah-quiz__q">' + pergunta + '</p>';
        if (dica) html += '<p class="lah-quiz__hint">' + dica + '</p>';
        html += '<div class="lah-quiz__opts" data-quiz-grupo="' + nome + '"' +
            (multiplo ? ' data-quiz-multiplo="1"' : '') + '>';

        opcoes.forEach(function (o) {
            html += '<button type="button" class="lah-quiz__opt" data-quiz-valor="' +
                o.valor + '">' + o.rotulo + '</button>';
        });

        return html + '</div>';
    }

    function criarQuiz(etapa) {
        if (etapa.querySelector('.lah-quiz')) return true;

        var box = document.createElement('div');
        box.className = 'lah-quiz';

        box.innerHTML =
            '<button type="button" class="lah-quiz__toggle" data-quiz-toggle>' +
            '<span class="lah-quiz__toggle-icon">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 1 1 3.2 2.4c-.5.2-.7.6-.7 1.1v.5"/><path d="M12 17v.3"/>' +
            '</svg></span>' +
            '<span><span class="lah-quiz__toggle-title">Descubra suas lentes rapidamente</span>' +
            '<span class="lah-quiz__toggle-sub">Responda 3 perguntas rápidas e indicamos a combinação certa</span></span>' +
            '<span class="lah-quiz__chev">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<path d="M6 9l6 6 6-6"/></svg></span>' +
            '</button>' +
            '<div class="lah-quiz__body">' +
            grupo('No dia a dia, onde você mais usa os óculos?',
                  'Pode marcar mais de um.', 'usos', [
                { valor: 'telas', rotulo: 'Computador e celular' },
                { valor: 'perto', rotulo: 'Leitura e trabalho de perto' },
                { valor: 'dirige', rotulo: 'Dirigindo' },
                { valor: 'ar_livre', rotulo: 'Atividades ao ar livre' }
            ], true) +
            grupo('Você alterna muito entre olhar de perto e de longe?', '', 'alterna', [
                { valor: 'muito', rotulo: 'O tempo todo' },
                { valor: 'as_vezes', rotulo: 'Às vezes' },
                { valor: 'pouco', rotulo: 'Pouco' }
            ], false) +
            grupo('Você já sabe o seu grau?',
                  'Está na sua receita. Se não souber, tudo bem.', 'grau', [
                { valor: 'ate275', rotulo: 'Até 2,75' },
                { valor: 'ate475', rotulo: 'Entre 3 e 4,75' },
                { valor: 'acima5', rotulo: 'Acima de 5' },
                { valor: 'naosei', rotulo: 'Não sei ainda' }
            ], false) +
            '<div class="lah-quiz__result" data-quiz-result></div>' +
            '</div>';

        /* POSICAO: topo da etapa, logo abaixo do titulo. Depois do titulo, e
           nao antes: o titulo diz em que etapa a pessoa esta. */
        var titulo = etapa.querySelector('.product-lens-step-title');

        if (titulo && titulo.parentNode === etapa) {
            etapa.insertBefore(box, titulo.nextSibling);
        } else if (titulo && titulo.parentNode && titulo.parentNode.parentNode === etapa) {
            etapa.insertBefore(box, titulo.parentNode.nextSibling);
        } else {
            etapa.insertBefore(box, etapa.firstChild);
        }

        ligarEventos(box);
        return true;
    }

    function ligarEventos(box) {
        box.querySelector('[data-quiz-toggle]').addEventListener('click', function () {
            var abrindo = !box.classList.contains('is-open');
            box.classList.toggle('is-open', abrindo);
            if (abrindo) track('lens_quiz_aberto', {});
        });

        box.addEventListener('click', function (event) {
            var opt = event.target.closest('.lah-quiz__opt');
            if (!opt) return;

            var grupoEl = opt.parentElement;
            var nome = grupoEl.getAttribute('data-quiz-grupo');
            var valor = opt.getAttribute('data-quiz-valor');
            var multiplo = grupoEl.hasAttribute('data-quiz-multiplo');

            if (multiplo) {
                opt.classList.toggle('is-on');
                var idx = respostas.usos.indexOf(valor);
                if (idx === -1) {
                    respostas.usos.push(valor);
                } else {
                    respostas.usos.splice(idx, 1);
                }
            } else {
                Array.prototype.forEach.call(
                    grupoEl.querySelectorAll('.lah-quiz__opt'),
                    function (b) { b.classList.toggle('is-on', b === opt); }
                );
                respostas[nome] = valor;
            }

            /* O resultado aparece quando as duas perguntas decisivas estao
               respondidas. Os usos refinam, mas nao bloqueiam. */
            if (respostas.alterna && respostas.grau) {
                montarResultado(box.querySelector('[data-quiz-result]'));
            }
        });
    }

    /* O quiz vive na etapa de campo de visao, exclusiva do caminho multifocal. */
    function aplicarQuiz() {
        var etapa = acharEtapa(STEP_CAMPO);
        if (!etapa) return;

        criarQuiz(etapa);

        /* ---------------------------------------------------------------
           O OBSERVADOR SE DESLIGA depois de criar o quiz.

           Ele existia so para esperar a etapa de campo de visao ser montada
           pelo Alpine. Criado o quiz, nao ha mais nada a observar — e manter o
           observador vivo significaria acordar a cada repintura do
           configurador, pelo resto da visita, para concluir que nao ha nada a
           fazer. Num celular simples, isso custa.
           --------------------------------------------------------------- */
        if (observer) {
            observer.disconnect();
            observer = null;
        }
    }

    aplicarQuiz();

    if (!document.querySelector('.lah-quiz') && window.MutationObserver) {
        var pendente = false;

        observer = new MutationObserver(function () {
            if (pendente) return;
            pendente = true;
            requestAnimationFrame(function () {
                pendente = false;
                aplicarQuiz();
            });
        });

        observer.observe(root, { childList: true, subtree: true });
    }
})();
